import { useApi } from "@utils/useApi";
import { UnityClient, UnityExperienceStatus } from "@lib/ShiOneClient";
import { useMutation } from "@tanstack/react-query";

export default function useUpdateUnityStatus() {
  const api = useApi(UnityClient);

  return useMutation({
    mutationFn: async (status: UnityExperienceStatus) => {
      return await api.updateUnityStatus(status);
    },
  });
}